export * from './auto-slider';



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/index.js